import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessKe311271Status: 'idle',
    startProcessKe311271Error: undefined as any,
    loadUserParamsProcessKe311271Status: 'idle',
    loadUserParamsProcessKe311271Error: undefined as any,

    processKe311271List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessKe311271 = createAsyncThunk('processKe311271Slice/startProcessKe311271', async ({ processKe311271 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessKe311271/`,
        prepareData(processKe311271),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessKe311271Status } = getState().processKe311271Slice
        return startProcessKe311271Status !== 'pending'
    }
})

export const loadUserParamsProcessKe311271 = createAsyncThunk('processKe311271Slice/loadUserParamsProcessKe311271', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessKe311271/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessKe311271Status } = getState().processKe311271Slice
        return loadUserParamsProcessKe311271Status !== 'pending'
    }
})

const ProcessKe311271Slice = createSlice({
    name: 'processKe311271Slice',
    initialState,
    reducers: {
        resetstartProcessKe311271: (state) => {
            state.job = undefined
            state.startProcessKe311271Error = undefined
        },
        resetstartProcessKe311271Error: (state) => {
            state.startProcessKe311271Error = undefined
        },
        resetloadUserParamsProcessKe311271: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessKe311271Error = undefined
        },
        resetloadUserParamsProcessKe311271Error: (state) => {
            state.loadUserParamsProcessKe311271Error = undefined
        },
        removeFromProcessKe311271ListById: (state, action) => {
            state.processKe311271List = state.processKe311271List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessKe311271ListByIds: (state, action) => {
            state.processKe311271List = state.processKe311271List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processKe311271List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessKe311271Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processKe311271List = []
            state.startProcessKe311271Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessKe311271.pending, (state) => {
            state.startProcessKe311271Status = 'pending'
            state.startProcessKe311271Error = undefined
        })
        builder.addCase(startProcessKe311271.fulfilled, (state, action) => {
            state.startProcessKe311271Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessKe311271.rejected, (state, action) => {
            state.startProcessKe311271Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessKe311271Error = action.error.message
            } else {
                state.startProcessKe311271Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessKe311271.pending, (state) => {
            state.loadUserParamsProcessKe311271Status = 'pending'
            state.loadUserParamsProcessKe311271Error = undefined
        })
        builder.addCase(loadUserParamsProcessKe311271.fulfilled, (state, action) => {
            state.loadUserParamsProcessKe311271Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessKe311271.rejected, (state, action) => {
            state.loadUserParamsProcessKe311271Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessKe311271Error = action.error.message
            } else {
                state.loadUserParamsProcessKe311271Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcessKe311271,
    resetstartProcessKe311271Error,
    resetloadUserParamsProcessKe311271,
    resetloadUserParamsProcessKe311271Error,
    removeFromProcessKe311271ListById,
    removeFromProcessKe311271ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessKe311271Slice.actions
export default ProcessKe311271Slice.reducer
